export default __webpack_public_path__ + "static/media/regulatory--truck-route--g1.630b0b24.png";